/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { Card } from './styles';

interface PriceProp {
  label: string;
  price: number;
}
export interface IPaymentSummaryProps {
  title: string;
  desc?: string;
  summaryTitle: string;
  prices?: PriceProp[];
  subTotalLabel: string;
  taxLabel: string;
  taxPrice: string;
  totalLabel: string;
  onPaymentClick?(): void;
  totalDesc?: string;
  isNotTitle?: boolean;
  setShowModal?(val: any): void;
  buttonVariant?: string;
  buttonLabel: string;
}

export const PaymentSummary = ({
  prices,
  buttonLabel,
  taxPrice,
  desc,
  subTotalLabel,
  summaryTitle,
  setShowModal,
  taxLabel,
  buttonVariant,
  title,
  isNotTitle,
  onPaymentClick,
  totalDesc,
  totalLabel,
}: IPaymentSummaryProps) => {
  const [subTotal, setSubTotal] = useState(0);
  console.log('li->', prices);

  useEffect(() => {
    let val = 0;
    val += prices?.price;
    // prices.map((item) => {
    //   val += item?.price;
    // });
    setSubTotal(val);
  }, [prices]);

  const findTotal = () => {
    const total = subTotal.toString();
    //+ parseFloat(taxPrice?.substring(1))).toString();
    let ind = total.indexOf('.');
    return total;
  };

  return (
    <Card className="p-4 mb-4">
      <h5 className="text-center mb-3">{summaryTitle}</h5>
      <h6 className="text-center mb-3">{prices?.type}</h6>

      <div className="d-flex justify-content-between">
        <h6>{prices?.paymentFor}</h6>
        <h6>{prices?.price}</h6>
      </div>

      <hr />
      <div className="d-flex justify-content-between">
        <h6>{subTotalLabel}</h6>
        <h6>{subTotal}</h6>
      </div>
      <div className="d-flex justify-content-between">
        <h6>{taxLabel}</h6>
        <h6>{taxPrice}</h6>
      </div>
      <hr />
      <div className="d-flex justify-content-between">
        <div>
          <h6>{totalLabel}</h6>
          {totalDesc && <span>{totalDesc}</span>}
        </div>
        <h5>{findTotal()}</h5>
      </div>
      {/* {!isNotTitle &&

  
    <Button variant={buttonVariant} className="mx-auto mt-4 d-flex" onClick={() => onPaymentClick && onPaymentClick()}>
      {buttonLabel}
  </Button>} */}
    </Card>
  );
};
